import React from 'react';

/** 아이템 카드 기본(이미지 없음) 플레이스홀더 — 스택된 카드 */
const ItemCardStackIcon: React.FC<{ size?: number; exhausted?: boolean }> = ({
  size = 48,
  exhausted = false,
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <rect
      x="2"
      y="6"
      width="12"
      height="16"
      rx="2"
      fill={exhausted ? '#e0e0e0' : '#ffffff'}
      stroke={exhausted ? '#999' : '#555'}
      strokeWidth="1.5"
      transform="rotate(-10 8 14)"
    />
    <rect
      x="6"
      y="4"
      width="12"
      height="16"
      rx="2"
      fill={exhausted ? '#e8e8e8' : '#f8f8f8'}
      stroke={exhausted ? '#999' : '#555'}
      strokeWidth="1.5"
    />
    <rect
      x="10"
      y="6"
      width="12"
      height="16"
      rx="2"
      fill={exhausted ? '#eee' : '#fafafa'}
      stroke={exhausted ? '#999' : '#555'}
      strokeWidth="1.5"
      transform="rotate(10 16 14)"
    />
  </svg>
);

export default ItemCardStackIcon;
